// extracted by mini-css-extract-plugin
export default {"about":"AboutButton_about__6-HDG"};